"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BalancesMenuItemComponent = _interopRequireDefault(require("./BalancesMenuItemComponent"));
var _MenuComponent = _interopRequireDefault(require("../Menu/MenuComponent"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./BalancesMenuComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var balancesClasses = (0, _cssClassesHelper.getBEMClasses)('balances-menu');
var BalancesMenuComponent = function BalancesMenuComponent(props) {
  var menuItems = props.positions.map(function (position) {
    return /*#__PURE__*/_react["default"].createElement(_BalancesMenuItemComponent["default"], {
      key: position.ProductId,
      position: position,
      selected: position.ProductId === props.selectedProductId,
      onItemClick: props.selectPositionAndSave
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_MenuComponent["default"], {
    customClass: balancesClasses(),
    dataTest: "Asset List"
  }, menuItems);
};
BalancesMenuComponent.propTypes = {
  positions: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = BalancesMenuComponent;